<template>
    <settings-wrapper title="Space settings" section="Users">
        <v-card class="overflow-hidden d-flex">
            <v-tabs v-model="tab">
                <v-tab v-for="tab in tabs" :key="tab.tabName">
                    <v-icon class="mr-1" small>{{ tab.icon }}</v-icon>
                    {{ tab.tabName }}
                </v-tab>
            </v-tabs>
        </v-card>

        <v-tabs-items class="mt-7" v-model="tab">
            <v-tab-item v-for="tab in tabs" :key="tab.tabName">
                <component :is="tab.component"></component>
            </v-tab-item>
        </v-tabs-items>
    </settings-wrapper>
</template>

<script>
import SettingsWrapper from '@/components/SettingsWrapper.vue'
const SpaceUsers = () => import('../components/SpaceUsers.vue')
const SpaceInvitations = () => import('../components/SpaceInvitations.vue')

export default {
    name: 'SpaceUserManagement',
    components: { SpaceUsers, SpaceInvitations, SettingsWrapper },
    data() {
        return {
            tab: null,
            tabs: [
                { tabName: 'Users', icon: 'mdi-account-group-outline', component: 'SpaceUsers' },
                { tabName: 'Invitations', icon: 'mail', component: 'SpaceInvitations' }
            ]
        }
    },
    mounted() {
        this.$store.dispatch('spaceStore/fetchSpaceUsers', this.$route.params.sid)
        this.$store.dispatch('spaceStore/fetchSpaceInvitations', this.$route.params.sid)
    }
}
</script>
